module.exports = __webpack_public_path__ + "static/media/ic-school-dropdown.50da0eed.svg";